import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'Pods/Shared/Tooltip'

import StatsNumber from './StatsNumber'

function StatsNumberContainer({
  tooltipText, tooltipId, value, title, format,
}) {
  return (
    <div className="stats-tooltip-container">
      <Tooltip
        tooltipClassName="tooltip--medium"
        id={`dashboard__stats-models-${tooltipId}`}
        content={tooltipText}
      >
        <StatsNumber value={value} title={title} format={format} />
      </Tooltip>
    </div>
  )
}

StatsNumberContainer.propTypes = {
  tooltipText: PropTypes.string.isRequired,
  tooltipId: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
}

export default StatsNumberContainer
